module.exports = __webpack_public_path__ + "img/72-d2c5f4.png";